var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.295,
    r: 15,
    fill: "#017E89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.418 8.96686H7.58203C6.70794 8.96686 6 9.67919 6 10.5489V20.0411C6 20.9159 6.71314 21.6231 7.58203 21.6231H22.418C23.2847 21.6231 24 20.9189 24 20.0411V10.5489C24 9.68074 23.2949 8.96686 22.418 8.96686ZM22.1964 10.0215C21.8732 10.343 16.3107 15.8762 16.1187 16.0673C15.8198 16.3661 15.4226 16.5306 15 16.5306C14.5774 16.5306 14.1802 16.3661 13.8803 16.0663C13.7512 15.9378 8.25011 10.4657 7.80359 10.0215H22.1964ZM7.05469 19.8264V10.7642L11.6123 15.2978L7.05469 19.8264ZM7.80425 20.5684L12.36 16.0416L13.1356 16.813C13.6336 17.3111 14.2957 17.5853 15 17.5853C15.7043 17.5853 16.3664 17.3111 16.8635 16.814L17.64 16.0416L22.1957 20.5684H7.80425ZM22.9453 19.8264L18.3877 15.2978L22.9453 10.7642V19.8264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFooter);
export default __webpack_public_path__ + "static/media/email-footer.88b77aa1ad495e64b9c08de3233079d7.svg";
export { ForwardRef as ReactComponent };